import { Component, OnInit, ViewChild } from '@angular/core';
import { IGlobalHeaderProps } from '@amobee/component-library';
import { UserService } from './services/user.service';
import { UserInfo } from './core/classes/user-info';
import { ModalService } from './services/modal.service';
import { ModalComponent } from './common/components/modal/modal.component';
import { BreadcrumbService } from './services/breadcrumb.service';
import * as React from 'react';
import { OktaAuthService } from '@okta/okta-angular';
import { Subscription } from 'rxjs/internal/Subscription';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../environments/environment';
import { AuthenticationService } from './services/authentication.service';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'ccp-root',
    templateUrl: './ccp.component.html'
})
export class AppComponent implements OnInit {
    public isAuthenticated: boolean;
    private authenticationStateSub: Subscription;
    public globalHeaderProps: IGlobalHeaderProps = {
        productName: React.createElement("a", { className: 'product-title', title: "Planner", href: "#" }, "Planner"),
        accentColor: "#E75556",
        menuItems: [{
            label: 'Planner',
            icon: 'ProductMediaPlans',
            active: true
        }],
        buttons: [{
            icon: 'User',
            menuItems: [
                {
                    label: '',
                    disabled: true
                },
                {
                    label: 'Logout',
                    onClick: () => {
                        localStorage.clear();
                        this.authenticationService.updateAuthenticationState(false);
                        if(window['__ccpEnv'].SSOPortalEnabled) {
                            window.location.href = window['__ccpEnv'].SSOPortalHostname + window['__ccpEnv'].SSOPortalLogoutUri;
                        } else {
                            let ssoLoginUrl = window['__ccpEnv'].SSOManagerUrl + '/users/logout';
                            this.http.post(
                                ssoLoginUrl,
                                ''
                            ).toPromise().then((resp) => {
                                window.location.href = window['__ccpEnv'].uiDomain + '/ssoLogout.html'
                            });
                        }
                    }
                }
            ]
        }],
        navbarZIndex: 1,
        dimmerZIndex: 100,
        disableSearch: true
    };
    public breadcrumb: Array<any> = [];

    @ViewChild(ModalComponent, { static: true }) modalComponent: ModalComponent;

    constructor(
        private userService: UserService,
        private modalService: ModalService,
        private breadcrumbService: BreadcrumbService,
        private oktaAuth: OktaAuthService,
        private cookieService: CookieService,
        private authenticationService: AuthenticationService,
        private http: HttpClient
    ) {
        // Subscribe to authentication state changes
        this.authenticationStateSub = this.authenticationService.authenticationState.subscribe((isAuthenticated: boolean) => {
            this.isAuthenticated = isAuthenticated;
            if (isAuthenticated) {
                this.oktaAuth.getAccessToken().then((token: string) => {
                    if (!this.cookieService.check('planner_lastToken') || this.cookieService.get('planner_lastToken') != token) {
                        let expDate = new Date(Date.now() + (12 * 60 * 60 * 1000)); // 12 hour cookie
                        let ssoLoginUrl = window['__ccpEnv'].SSOManagerUrl + '/web/login?accessToken=' + token + '&app=' + window['__ccpEnv'].appAuthorityName;
                        document.getElementById('loginFrame').setAttribute('src', ssoLoginUrl);
                        this.cookieService.set('planner_lastToken', token, expDate, '/', window['__ccpEnv'].cookieDomain, true, 'None');
                    }
                    this.userService.getUser().then((userObject: UserInfo) => {
                        if (userObject.hasPermission('ClientServices') ||
                            (userObject.hasPermission('CrossChannelPlanner.UserList') || userObject.hasPermission('CrossChannelPlanner.MarketList'))) {
                            this.globalHeaderProps.buttons[0].menuItems[0].label = userObject.username;
                        } else {
                            localStorage.clear();
                            window.location.href = window['__ccpEnv'].SSOPortalHostname + window['__ccpEnv'].SSOPortalUnauthUri;
                        }
                    }).catch((err) => {
                        console.log(err);
                        // if user endpoint returns error but user is logged in, there is something wrong with the token
                        localStorage.clear();
                        this.authenticationService.updateAuthenticationState(false);
                        if(window['__ccpEnv'].SSOPortalEnabled) {
                            window.location.href = window['__ccpEnv'].SSOPortalHostname + window['__ccpEnv'].SSOPortalLogoutUri;
                        } else {
                            let ssoLoginUrl = window['__ccpEnv'].SSOManagerUrl + '/users/logout';
                            this.http.post(
                                ssoLoginUrl,
                                ''
                            ).toPromise().then((resp) => {
                                window.location.href = window['__ccpEnv'].uiDomain + '/ssoLogout.html'
                            });
                        }
                    });
                }).catch((err) => {
                    console.log(err);
                });
            }
        });
    }

    public ngOnInit() {
        // Get the authentication state for immediate use
        this.oktaAuth.isAuthenticated().then((isAuthenticated: boolean) => {
            this.isAuthenticated = isAuthenticated;
            if (isAuthenticated) {
                this.authenticationService.updateAuthenticationState(true);
            }
        });
        this.modalService.modal = this.modalComponent;
        this.breadcrumbService.sharedBreadcrumb.subscribe(breadcrumb => this.breadcrumb = breadcrumb);
    }
}
